import { useState } from 'react'
import { Box, IconButton, Typography, Grid, Divider } from '@mui/material'
import { FilterButton } from '../common'
import { TableLimit } from '@/@core/components/mui/TableLimit'
import CompanySelection from '../selection/CompanySelection'
import { useRouteQuery, useTranslator } from '@/hooks'
import InputDateField from '../common/input/InputDateField'
import { SelectColumns } from '../common/SelectColumns'
import AppLogs from '../common/AppLogs'
import { ActivityLogTypeEnum } from '@/@data/activities'

interface ColumnOption {
  key: string
  label: string
}

interface AttendanceFilterProps {
  onSearch?: (value: string) => void
  onAddEmployee?: () => void
  onSelectColumns?: (columns: string[]) => void
  columns?: ColumnOption[]
  visibleColumns?: string[]
}

export const AttendanceFilter = ({
  columns,
  visibleColumns,
    onSelectColumns
}: AttendanceFilterProps) => {
  const { __ } = useTranslator()
  const { updateQuery, searchQuery } = useRouteQuery()
  const [filter, setFilter] = useState(true)
  const [isOpenLogs, setIsOpenLogs] = useState(false)

  return (
    <>
    <Box
      sx={{
        display: 'flex',
        padding: '20px',
        gap: 4,
        flexDirection: 'column'
      }}
    >
      {filter && (
        <>
          <Box className='mb-3'>
            <Typography variant='h6' className='mb-3'>
              {__('Filters')}
            </Typography>
            <Grid container spacing={2}>
              <Grid size={6}>
                <CompanySelection
                  value={searchQuery.get('company_id') || ''}
                  onChange={company_id => {
                    updateQuery({ company_id, page: 1 })
                  }}
                  onClear={() => {
                    updateQuery({ company_id: undefined, page: 1 })
                  }}
                />
              </Grid>
              <Grid size={6}>
                <InputDateField
                  value={searchQuery.get('month') || ''}
                  placeholder={__('Select Month')}
                  onChange={month => {
                    updateQuery({ month })
                  }}
                  picker='month'
                  format='YYYY-MM'
                />
              </Grid>
            </Grid>
          </Box>
          <Divider />
        </>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <TableLimit />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <FilterButton filter={filter} onFilter={() => setFilter(!filter)} />

          <div>
            <SelectColumns
              options={columns?.map(column => {
                const isChecked = visibleColumns?.includes(column.key) ?? true

                return {
                  id: column.key,
                  label: column.label,
                  checked: isChecked
                }
              }) || []}
              onChange={(options) => {
                const selectedColumns = options
                  .filter(option => option.checked)
                  .map(option => option.id)

                onSelectColumns?.(selectedColumns)
              }}
              buttonText={__('Columns')}
            />
          </div>

          <IconButton
            size='small'
            sx={{
              width: 40,
              height: 40,
              backgroundColor: '#f5f5f5',
              '&:hover': {
                backgroundColor: '#e0e0e0'
              }
            }}
            onClick={() => {
              setIsOpenLogs(true)
            }}
          >
            <i className='tabler-history text-[#2f2b3de6]' style={{ fontSize: 18 }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
    <AppLogs
      open={isOpenLogs}
      setOpen={setIsOpenLogs}
      title={__('History Menu Attendance')}
      object_type={ActivityLogTypeEnum.Attendance}
      objectId={searchQuery.get('company_id') || ''}
    />
    </>
  )
}
